import { FC, useEffect, useState, ReactNode } from 'react';

import { cookieService } from '@services/cookie.service';
import { useAuthUser } from '@redux/selectors/auth';

import { isUserAuthenticated } from '../navigation/routingHelpers';

type Props = {
  children: ReactNode;
};

export const AuthProvider: FC<Props> = ({ children }) => {
  const { user: authUser, isAnonymous } = useAuthUser();
  const [isAuthReady, setIsAuthReady] = useState<boolean>(false);

  useEffect(() => {
    const hasAuthToken = !!cookieService.getAuthToken();
    const hasAnonymousId = !!cookieService.getAnonymousUserId();

    if (authUser || hasAuthToken || hasAnonymousId) {
      setIsAuthReady(true);
    } else {
      const timer = setTimeout(() => {
        setIsAuthReady(true);
      }, 50);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [authUser]);

  useEffect(() => {
    if (!authUser) {
      return;
    }

    const isAuthenticated = isUserAuthenticated(authUser, isAnonymous);

    if (isAuthenticated) {
      cookieService.removeAnonymousUserId();
    } else if (isAnonymous) {
      cookieService.removeAuthToken();
      if (authUser?.id) {
        cookieService.ensureAnonymousUserId(authUser?.id);
      }
    }
  }, [authUser, isAnonymous]);

  if (!isAuthReady) {
    return null;
  }

  return <>{children}</>;
};
